<template>
  <div class="ion-page">
    <ion-header class="rp-mobile">
      <ion-toolbar class="mobile-header-toolbar">
        <ion-buttons v-slot: start>
          <ion-back-button default-href="/login" @click="navigatePreviousPage"></ion-back-button>
          <ion-title>Forgot Password</ion-title>
        </ion-buttons>
        
      </ion-toolbar>
    </ion-header>
    <ion-header class="rp-desktop">
      <ion-toolbar class="app-toolbar">
        <ion-buttons v-slot: start>
          <ion-back-button default-href="/login" @click="navigatePreviousPage"></ion-back-button>
          <ion-title>Forgot Password</ion-title>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ForgotPassword />
    </ion-content>
  </div>
</template>

<script>
import { IonHeader, IonToolbar, IonButtons, IonBackButton, IonTitle, IonContent } from "@ionic/vue";
import { defineComponent } from "vue"
import ForgotPassword from "@/components/account/ForgotPassword.vue";
export default defineComponent ({
    name: 'forgotPassword',
    components: {
      IonHeader, 
      IonToolbar, 
      IonButtons, 
      IonBackButton, 
      IonTitle, 
      IonContent,
      ForgotPassword
    },
    data() {
        return {

        }
    },
    methods: {
      navigatePreviousPage() {
        this.$router.go(-1)
      }
    }
})
</script>

<style scoped>
@media (max-width: 768px) {
  .mobile-header-toolbar {
    --background: #21b24b;
  }
  .mobile-header-toolbar {
    height: 56px;
    padding-top: 1px;
  }
  .mobile-header-toolbar ion-title {
    color: #ffffff;
  }
  .mobile-header-toolbar ion-buttons {
    color: #ffffff;
    --background: #ffffff;
  }
  .mobile-header-toolbar ion-back-button {
    color: #ffffff !important;
    margin-right: 13px;
  }
}
</style>